<template>
  <div :style="style">
    <editor-item
      v-for="element of value.content"
      :key="element.uid"
      :value="element"
      @loaded="$emit('loaded', $event)"
      @loading="$emit('loading', $event)"
    />
  </div>
</template>
<script>
export default {
  name: 'EditorItemGroup',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    style() {
      return {
        overflow: this.value.crop ? 'hidden' : 'visible'
      };
    }
  }
};
</script>
